import { defineStore } from 'pinia'
import { shallowRef } from 'vue'
import { v4 as uuid4 } from 'uuid'

export const useModalStack = defineStore('modalstack', () => {
  const stack = shallowRef([])
  const state = {}
  let context

  async function push({ component, onClose, props, events, provide }) {
    const stk = [...stack.value]
    const id = uuid4()
    let cmp = component

    if (cmp instanceof Function) {
      const res = await cmp()
      cmp = res.default
    }

    stk.push({
      id, // using this as key in v-for loop, should be unique
      onClose,
      component: cmp,
      props: { ...(props || {}), modalstack: true },
      events: {
        ...(events || {}),
        ['modalstack:close']: pop,
      },
      provide,
    })

    stack.value = stk
  }

  function pop(data = null) {
    const stk = [...stack.value]
    const stki = stk.pop()
    if (!stki) return
    if (data !== null && stki.onClose instanceof Function) {
      stki.onClose(data)
    }
    delete state[stki.id]
    stack.value = stk
  }

  function stateGet(id) {
    return state[id]
  }

  function contextSet(data) {
    context = data
  }

  function contextGet() {
    return context
  }

  // save state for current visible modal
  function stateSet(payload) {
    let x = stack.value[stack.value.length - 1]
    if (!x) {
      console.error('no modal')
    }
    state[x.id] = payload
  }

  function closeAll() {
    for (const [k] of Object.entries()) {
      delete state[k]
    }
    stack.value = []
  }

  return {
    push,
    pop,
    stack,
    closeAll,
    stateSet,
    stateGet,
    contextSet,
    contextGet,
  }
})
